import { selfProvision } from "../functions.js";

export function renderRolePicker(root, { onComplete }) {
  root.innerHTML = `
    <section class="role-picker">
      <h2>Kas tu esi?</h2>
      <p class="lead">Izvēlies savu lomu, lai turpinātu.</p>
      <div class="role-options">
        <button class="role-btn" data-role="child">
          <span class="role-icon">🎒</span>
          <span class="role-label">Skolēns</span>
          <span class="role-desc">Risinu uzdevumus</span>
        </button>
        <button class="role-btn" data-role="parent">
          <span class="role-icon">👨‍👩‍👧</span>
          <span class="role-label">Vecāks</span>
          <span class="role-desc">Sekoju bērna progresam</span>
        </button>
      </div>
      <p class="role-error hidden"></p>
    </section>`;

  const buttons = root.querySelectorAll(".role-btn");
  const errorEl = root.querySelector(".role-error");

  buttons.forEach((btn) => {
    btn.addEventListener("click", async () => {
      const role = btn.dataset.role;
      buttons.forEach((b) => (b.disabled = true));
      errorEl.classList.add("hidden");
      try {
        await selfProvision({ role });
        onComplete(role);
      } catch (err) {
        console.error("selfProvision failed:", err);
        errorEl.textContent = "Kļūda: " + err.message;
        errorEl.classList.remove("hidden");
        buttons.forEach((b) => (b.disabled = false));
      }
    });
  });
}
